// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"96964e74","453":"7b5642e3","455":"d5110e78","977":"e26c0191"}[chunkId] + ".chunk.js";
};